<div class="container-fluid">
    <nav class="context-breadcrumb" aria-label="breadcrumb  rounded ">
        <ol class="breadcrumb  shadow-lg">
            <li class="breadcrumb-item"><a routerLink="/utilisateur/admin/dashboard">Dashboard administration</a></li>
            <li class="breadcrumb-item active" aria-current="page">Gestion des gestionnaires</li>
        </ol>
    </nav>
    <div class="row">
        <div class="col-sm-6">
            <div class="card  border-0">
                <div class="card-header generalbgColorV2">
                    <h5 class="card-title text-center text-white">ajouter un gestionnaire</h5>
                </div>
                <div class="card-body text-black-50 g-3">
                    <form [formGroup]="gestionaireForm" #f="ngForm" (ngSubmit)="addGestionaire(f.value)">

                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddress" class="">nom </label>
                                <input formControlName="lastName" type="text" class="form-control" id="lastName"
                                    placeholder="">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="">prenom </label>
                                <input formControlName="firstName" type="text" class="form-control" id="firstName"
                                    placeholder="">
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="">email de connection</label>
                                <input formControlName="email" type="text" class="form-control" id="email"
                                    placeholder="">
                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputAddress2" class="">contact</label>
                                <input formControlName="phone" type="text" class="form-control" id="phone"
                                    placeholder="">
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputPassword4" class="">mot de passe</label>
                                <input formControlName="password" type="password" class="form-control" id="password">

                            </div>
                            <div class="form-group col-md-6">
                                <label for="inputPassword4" class="">confirmation mot de passe</label>
                                <input formControlName="confirmPassword" type="password" class="form-control"
                                    id="confirmPassword">
                            </div>
                        </div>
                        <button type="submit" class="btn btn-primary mt-2"
                            [disabled]="!gestionaireForm.valid">Ajouter</button>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card   border-0">
                <div class="card-header generalbgColorV2">
                    <h5 class="card-title  text-center text-white">Liste des Gestionnaire</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-6" *ngFor="let p of gestionaireList;">
                            <div class="card   border-0">
                                <!--<div class="card-header generalbgColorV2">
                                    <h5 class="card-title text-success text-center"></h5>
                                  </div>-->
                                <div class="card-body ">
                                    <h6 class="card-title ">Nom<strong class="ml-3 text-uppercase">{{p.firstName}}
                                            {{p.lastName}}</strong>
                                    </h6>
                                    <h6 class="card-title ">Email<strong
                                            class="ml-3 text-uppercase">{{p.username}}</strong>
                                    </h6>
                                    <h6 class="card-title ">Téléphone<strong
                                            class="ml-3 text-uppercase">{{p.phone}}</strong>
                                    </h6>
                                </div>
                                <div class="card-footer bg-transparent border-success">
                                    <div class="btn-group" role="group" aria-label="Basic example">
                                        <button type="button" class="btn btn-success">suspendre</button>
                                        <button type="button" class="btn btn-danger">supprimer</button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
